import React from "react";
import ContentSection from "./ContentSection";
import { useNavigate } from "react-router-dom";
function About() {
  const navigate = useNavigate();
  return (
    <ContentSection
      id="about"
      title="ABOUT US"
      paragraphs={[
        "",
        "Ava Rose Mortgages Ltd was founded and inspired by a moment of family joy, the birth of owner Michael Hunt’s first grandchild, Ava Rose. Her arrival marked a new chapter, and with it came the vision to create a mortgage and protection business built on the same values that family represents trust, security, care, and a commitment to brighter futures.  ",
        "At Ava Rose Mortgages, we believe securing a home should feel personal, supportive, and straightforward. Our name serves as a daily reminder of why we do what we do, helping individuals, couples, and families find the place where their own stories can begin. ",
        "With a focus on honest advice, tailored solutions, and exceptional service, Ava Rose Mortgages is here to guide you through every step of your home-buying journey and  provide the right protection for you and your family's needs in order to protect what matters to you and your family. ",
        "We will arrange an initial meeting to get a better idea of your circumstances and work out how we can support you best. At Ava Rose Mortgages, we cover the whole of the UK and appointments could be held face to face if within the local area, further afield we can offer phone or video calls at a time to suit you, including evenings and weekends.",
      ]}
      // image={AboutUsImage}
      imageAlt="Mortgage consultant"
      imagePosition="right"
      buttonText="Start your journey with us"
      onClick={() => {
        navigate("/contact");
      }}
      showDivider={true}
      backgroundColor="light"
    />
  );
}

export default About;
